<template>
  <div>
    <div class="course-bag" @click="gotoCourse">
      <div class="course-bag-img">
        <img :src="CourseBagItemData.coverImagUrl" alt="" />
        <div class="tag">
          {{ CourseBagItemData.tag }}
        </div>
      </div>
      <div class="course-bag-content">
        <div class="course-bag-title">{{ CourseBagItemData.title }}</div>
        <div class="course-bag-desc">
          <div class="author-name">
            <img class="author-portrait" :src="CourseBagItemData.avatar" />
            <div>{{ CourseBagItemData.authorName }}</div>
          </div>
          <div class="desc">{{ CourseBagItemData.subTitle }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Dialog } from 'vant'
export default {
  name: 'CourseBagItem',
  props: ['CourseBagItemData', 'couponNo'],
  methods: {
    gotoCourse() {
      const item = this.CourseBagItemData
      this.$store.commit('setCurrentBag', item)

      this.$router.push({
        path: './unlock-course',
        query: {
          setId: item.setId,
          productId: item.productId,
          couponNo: this.couponNo
        }
      })
    },
    showDialog() {
      const item = this.CourseBagItemData
      Dialog.confirm({
        title: '提示',
        message: `解锁课程《${item.title}》【第11节】0102收盘总结。确定吗？`
      })
        .then(() => {
          // on confirm
        })
        .catch(() => {
          // on cancel
        })
    }
  }
}
</script>

<style scoped lang="scss">
.course-bag {
  display: flex;
  padding: 10px;
  border-radius: 8px;
  background: rgba(245, 245, 245, 1);
  margin-bottom: 20px;
  .course-bag-img {
    position: relative;
    width: 200px;
    height: 112px;
    border-radius: 4px;
    .tag {
      position: absolute;
      top: 10px;
      left: 10px;
      background: rgba(0, 0, 0, 0.25);
      color: #ffffff;
      font-size: 24px;
      padding: 0 10px;
      border-radius: 4px;
    }
    img {
      width: 100%;
      height: 100%;
      display: block;
      border-radius: 4px;
    }
  }
  .course-bag-content {
    flex: 1;
    padding: 0 10px;
    margin-left: 20px;
    .course-bag-title {
      font-size: 32px;
      color: rgba(50, 50, 50, 1);
      margin-bottom: 10px;
    }
    .course-bag-desc {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 24px;
      .author-name {
        display: flex;
        align-items: center;
        color: rgba(50, 50, 50, 1);
        font-size: 24px;
        img {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          margin-right: 10px;
        }
      }
      .desc {
        width: fit-content;
        min-height: 48px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 80px;
        background: rgba(240, 175, 90, 1);
        color: rgba(50, 50, 50, 1);
        font-size: 24px;
        padding: 0 20px;
        max-width: 268px;
        flex: none;
        margin-left: 10px;
      }
    }
  }
}
</style>
